import * as React from "react";
import { cn } from "./utils";

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-xs font-medium uppercase tracking-[0.12em] text-slate-500",
      className
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
